export default __webpack_public_path__ + "static/1995-01-01_roles_MP.pdf";